module.exports = __webpack_public_path__ + "static/images/e042b9bf.svg";